import React from 'react';
import { NavLink } from 'react-router-dom';
import InformationModal from '../../../modals/infoModal.jsx';
import WarningModal from '../../../modals/warningModal.jsx';
import StatusSelectionModal from '../../../modals/statusSelectionModal.jsx';
import ImportInvoicesModal from '../../../modals/importInvoicesModal.jsx';
import ImportCostsModal from '../../../modals/importCostsModal.jsx';
import TripleStateCheckbox from '../../../controls/tripleStateCheckbox.jsx';
import moment from 'moment';
import numeral from 'numeral';
import { apiDownload, apiGet, apiPost } from '../../../services/apiClient';
import Grid from '../../../grid/grid.jsx';
import Forbidden from '../../forbidden/forbidden.jsx';
import {toast} from "react-toastify";
import { downloadFile } from '../../../services/files.js';
import { MAX_SELECTION_COUNT } from '../../../services/utils.js';

export default class CarrierParcelsTable extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            busyCount: 0,
            disableFilters: false,
            lastResponseError: null,
            columns: [
                {
                    renderTitle: () => this.renderSelectionTitle(),
                    fieldName: 'selection',
                    disableSort: true,
                    minWidth: 40,
                    expandPortion: 0,
                    cellClass: "text-center"
                },
                {
                    title: 'Дата создания',
                    fieldName: 'createdDate',
                    filterType: 'date',
                    minWidth: 120
                },
                {
                    title: 'Идентификатор посылки',
                    fieldName: 'number',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'Внешний номер посылки',
                    fieldName: 'externalNumber',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    renderTitle: () => this.renderStatusTitle(),
                    fieldName: 'status',
                    filterType: 'dropdown',
                    loadUrl: 'parcels/list/carrier/ref/parcelstatuses',
                    minWidth: 160
                },
                {
                    title: 'Вес, кг',
                    fieldName: 'weight',
                    filterType: 'number',
                    minValue: 0,
                    minWidth: 120,
                    cellClass: "text-right"
                },
                {
					renderTitle: () => <span>Объем, м<sup>3</sup></span>,
                    fieldName: 'volume',
                    filterType: 'number',
                    minValue: 0,
                    minWidth: 120,
                    cellClass: "text-right"
                },
                {
                    title: 'Адрес отправления',
                    fieldName: 'shipmentAddress',
                    filterType: 'string',
                    minWidth: 180
                },
                {
                    title: 'Адрес доставки',
                    fieldName: 'deliveryAddress',
                    filterType: 'string',
                    minWidth: 180
                },
                {
                    title: 'Дополнительная услуга',
                    fieldName: 'additionalServices',
                    filterType: 'dropdown',
                    loadUrl: 'parcels/list/carrier/ref/additionalServices',
                    disableSort: true,
                    minWidth: 180
                },
                {
                    title: 'Тип ТС',
                    fieldName: 'vehicleType',
                    filterType: 'dropdown',
                    loadUrl: 'parcels/list/carrier/ref/vehicleTypes',
                    minWidth: 160
                },
                {
                    title: 'Счет',
                    fieldName: 'invoiceNumber',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'Фактическая стоимость, р. с НДС',
                    fieldName: 'actualDeliveryCost',
                    filterType: 'number',
                    minValue: 0,
                    minWidth: 120,
                    cellClass: "text-right"
                }
            ],
            selectedParcelIds: [],
            isSelectedAll: false
        };

        this.infoModal = null;
        this.warningModal = null;
        this.statusSelectionModal = null;
        this.importInvoicesModal = null;
        this.importCostsModal = null;
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    loadData(settings, takeCount, skipCount, needOverlay) {
        this.updateBusyCount(needOverlay ? 1 : 0);
        return apiPost('parcels/list/carrier/all', { settings: settings, takeCount, skipCount })
            .then(data => {
                this.updateBusyCount(needOverlay ? -1 : 0);
                return data.entries;
            })
            .catch(err => {
                this.updateBusyCount(needOverlay ? -1 : 0);
                if (err.status > 401) {
                    this.setState({ lastResponseError: err.status });
                }
            });
    }

    downloadExcel() {
        this.updateBusyCount(1);
        let settings = this.grid.getSettings();
        apiPost('parcels/list/carrier/excel', { settings: settings })
            .then(data => {
                this.updateBusyCount(-1);
                let fileUrl = getApiBaseUrl() + 'files/' + data.result;
                window.location.href = fileUrl;
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    reload() {
        this.handleSelectedAllChange(false);
        this.grid.reload();
    }

    handleRowSelectionChanged(rowId, newChecked) {
        let newSelectedParcelIds = this.state.selectedParcelIds;
        if (newChecked && newSelectedParcelIds.indexOf(rowId) === -1) {
            newSelectedParcelIds.push(rowId);
        } else if (!newChecked) {
            let idIndex = newSelectedParcelIds.indexOf(rowId);
            if (idIndex >= 0) {
                newSelectedParcelIds.splice(idIndex, 1);
            }
        }
        this.setState({
            selectedParcelIds: newSelectedParcelIds,
            isSelectedAll: newSelectedParcelIds.length > 0 ? null : false
        });
    }

    handleSelectedAllChange(newChecked) {
        if (newChecked && !(this.selectedParcelIds && this.selectedParcelIds.length > 0)) {
            this.updateBusyCount(1);
            let settings = this.grid.getSettings();
            this.setState({ disableFilters: true });
            return apiPost('parcels/list/carrier/ids', { settings: settings })
                .then(data => {
                    this.updateBusyCount(-1);
                    if (data.ids && data.ids.length > MAX_SELECTION_COUNT) {
                        this.setState({ disableFilters: false });
                        toast.warning(`Нельзя выбрать более ${MAX_SELECTION_COUNT} записей`);
                    } else {
                        this.setState({
                            disableFilters: false,
                            selectedParcelIds: data.ids,
                            isSelectedAll: true
                        });
                    }
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                    this.setState({ disableFilters: false });
                });
        } else {
            this.setState({
                selectedParcelIds: [],
                isSelectedAll: false
            });
        }
    }

    handleFiltersChange() {
        this.handleSelectedAllChange(false);
    }

	loadSelectedParcelWaybills() {
        let title = 'Получение накладных';
		this.updateBusyCount(1);
		let request = {
			ids: this.state.selectedParcelIds
        };
        apiPost('parcels/list/documents/validate', request)
            .catch(err => {
                if (err.message) {
                    this.infoModal.open(title, err.message);
                }
            });
        apiDownload('parcels/list/documents/zip', request)
            .then(data => {
                this.updateBusyCount(-1);
                if (data && data.data) {
                    downloadFile(data);
                } else {
                    this.infoModal.open(title, 'Ошибка при получении файла');
                }
            })
            .catch(() => this.updateBusyCount(-1));
	}

	importInvoiceNumbers() {
        this.updateBusyCount(1);
		this.importInvoicesModal.open()
			.then(() => {
				this.updateBusyCount(-1);
				this.reload();
			})
			.catch(err => {
				this.updateBusyCount(-1);
			});
	}

	bulkChangeStatus() {
		let title = 'Массовая смена статуса посылок';
        this.updateBusyCount(1);
		apiPost('parcels/list/nextstatus/common', { ids: this.state.selectedParcelIds })
			.then(data => {
				if (!data.entries || data.entries.length < 1) {
					this.updateBusyCount(-1);
					this.infoModal.open(title, 'Не найдено ни одного статуса, доступного вам для перевода.');
				}
				else {
					let statuses = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
					this.statusSelectionModal.open(title, statuses)
						.then(nextStatus => {
							let request = {
								ids: this.state.selectedParcelIds,
								nextStatus: nextStatus
							};
							return apiPost('parcels/list/nextstatus/apply', request)
                                .then(data => {
                                    if (data && data.warningMessages) {
                                        toast.warning(data.warningMessages, {autoClose: 30000});
                                    }
									this.updateBusyCount(-1);
									this.reload();
								})
								.catch(err => {
                                    this.updateBusyCount(-1);
                                    if (err.totalError) {
                                        let title = 'Изменение статусов посылок';
                                        let resultMessage = 'Не соблюдены условия для смены статуса посылки:';
                                        resultMessage += '\n' + err.totalError;
                                        this.infoModal.open(title, resultMessage);
                                    }
								});
						})
						.catch(err => {
							this.updateBusyCount(-1);
						});
				}
			})
            .catch(err => {
                this.updateBusyCount(-1);
				if (err.message) {
					this.infoModal.open(title, err.message);
				}
            });
	}

    renderSelectionTitle() {
        let isBusy = this.state.busyCount > 0;
        return (
            <div className="text-center" style={{ width: "24px" }}>
                <TripleStateCheckbox checked={this.state.isSelectedAll}
                    onChange={e => this.handleSelectedAllChange(e)}
                    disabled={isBusy} />
            </div>
        );
    }

    renderStatusTitle() {
        return (
            <div>
                Статус
                <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" data-placement="bottom" title="Статус"
                    data-content="Создана → Отправлена агенту mailroom → Отправлена ТК → Подтверждена ТК → Отгружена → Доставлена → Требует согласования суммы → Сумма согласована → Счет выставлен → Завершена">
                    <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                </a>
            </div>
        );
    }

	checkHighlight(row) {
		return this.state.selectedParcelIds.indexOf(row.id) >= 0;
	}

    renderCellValue(row, column) {
        let isBusy = this.state.busyCount > 0;
        switch (column.fieldName) {
            case 'selection':
                return (
                    <input type="checkbox"
                        checked={this.state.selectedParcelIds.indexOf(row.id) >= 0}
                        onChange={e => this.handleRowSelectionChanged(row.id, e.target.checked)}
                        disabled={isBusy} 
					/>
                );
            case 'createdDate':
                return moment(row.createdDate).format("DD.MM.YYYY HH:mm");
            case 'number':
                let parcelLink = "/parcels/" + row.id;
                return <NavLink to={parcelLink}>{row.number}</NavLink>;
            case 'weight':
            case 'volume':
                return row[column.fieldName] ? numeral(row[column.fieldName]).format("0.00000") : '';
            default:
                return row[column.fieldName];
        }
    }

    importCosts() {
        this.updateBusyCount(1);
		this.importCostsModal.open()
			.then(() => {
				this.updateBusyCount(-1);
				this.reload();
			})
			.catch(err => {
				this.updateBusyCount(-1);
			});
	}

	renderImportCostsButton(isBusy) {	
        return (
            <div className="btn-group btn-tool">
                <button type="button"
                    className="btn btn-sm btn-flat btn-default dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="false"
                    disabled={isBusy}
                >
                    <span className="glyphicon glyphicon-cloud-upload"></span>
                    <span> Загрузка фактической стоимости</span>
                    <span className="caret" style={{ marginLeft: "4px" }}></span>
                </button>
                <ul className="dropdown-menu" role="menu">
                    <li>
                        <a href="/files/Delivery costs template.xlsx">
                            Скачать шаблон загрузки
                        </a>
                    </li>
                    <li>
                        <a onClick={() => this.importCosts()}>
                            Загрузить скачанный шаблон
                        </a>
                    </li>
                </ul>
            </div>
        );
	}


    render() {
        if (this.state.lastResponseError === 403) {
            return <Forbidden />;
        }

        let isBusy = this.state.busyCount > 0;

        let bulkChangeStatusTool = (
            <div className="btn-group btn-tool">
                <button type="button"
                    className="btn btn-sm btn-flat btn-default dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="false"
                    disabled={isBusy || this.state.selectedParcelIds.length === 0}
                >
					<span className="fa fa-edit"></span>
                    <span> Массовые операции</span>
                    <span className="caret" style={{ marginLeft: "4px" }}></span>
                </button>
                <ul className="dropdown-menu" role="menu">
					<li>
						<a onClick={() => this.bulkChangeStatus()}>
							Изменение статуса
						</a>
					</li>
                </ul>
            </div>
        );

        return (
            <div>
                <section className="content-header">
                    <h1>
                        Pooling Express
                    </h1>
                    <ol className="breadcrumb">
                        <li className="active"><i className="fa fa-inbox"></i> Pooling Express</li>
                    </ol>
                </section>
                <section className="content">
                    <div className="box grid-box" style={{ height: this.state.boxHeight }}>
                        <div className="box-header">
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.grid.reload()}
                                    disabled={isBusy}
                                >
                                    <span className="fa fa-refresh"></span>
                                </a>
                            </div>
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.grid.clearSettings()}
                                    disabled={isBusy}
                                >
                                    <span className="glyphicon glyphicon-remove"></span>
                                </a>
                            </div>
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.downloadExcel()}
                                    disabled={isBusy}
                                >
                                    <span className="glyphicon glyphicon-save-file"></span>
                                </a>
                            </div>
                            {bulkChangeStatusTool}
                            {this.renderImportCostsButton(isBusy)}
							<div className="btn-group btn-tool">
								<button type="button"
									className="btn btn-sm btn-flat btn-default dropdown-toggle"
									data-toggle="dropdown"
									aria-expanded="false"
									disabled={isBusy}
								>
									<span className="glyphicon glyphicon-cloud-upload"></span>
									<span> Загрузка счета из Excel</span>
									<span className="caret" style={{ marginLeft: "4px" }}></span>
								</button>
								<ul className="dropdown-menu" role="menu">
									<li>
										<a href="/files/Invoices template.xlsx">
											Скачать шаблон загрузки
										</a>
									</li>
									<li>
										<a onClick={() => this.importInvoiceNumbers()}>
											Загрузить скачанный шаблон
										</a>
									</li>
								</ul>
							</div>
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.loadSelectedParcelWaybills()}
                                    disabled={isBusy || this.state.selectedParcelIds.length === 0}
                                >
                                    <span className="glyphicon glyphicon-print"></span> Скачать накладные
                                </a>
                            </div>
                        </div>
                        <div className="box-body">
                            <Grid columns={this.state.columns}
                                loadData={(settings, take, skip, needOverlay) => this.loadData(settings, take, skip, needOverlay)}
                                isBusy={isBusy}
                                disableFilters={this.state.disableFilters}
                                gridKey="parcels"
                                onFiltersChange={() => this.handleFiltersChange()}
                                renderCellValue={(row, column) => this.renderCellValue(row, column)}
								checkHighlight={row => this.checkHighlight(row)}
                                ref={grid => this.grid = grid}
                            />
                        </div>
                    </div>
                </section>
                <InformationModal ref={modal => this.infoModal = modal} />
                <WarningModal ref={modal => this.warningModal = modal} />
                <StatusSelectionModal ref={modal => this.statusSelectionModal = modal} />
                <ImportInvoicesModal ref={modal => this.importInvoicesModal = modal} />
                <ImportCostsModal ref={modal => this.importCostsModal = modal} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/table/carrierParcelsTable.jsx